import React from 'react'
import { Button, Radio, Table, Modal, Icon, Grid, Message } from 'semantic-ui-react'
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import _ from 'lodash';
import { toastr } from 'react-redux-toastr';
import { singleLineText } from '../../../../common/RegexValidation';

let payload = {};
let selectedRoleArray = [];

class ContributorsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noRecord: false,
      packRole: 'contributor',
      checkValid: false,
      setError: null,
      firstName:"",
      lastName:""
    }
    this.handleUserSearch = this.handleUserSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleSelectParticipants = this.handleSelectParticipants.bind(this);
    this.addParticipants = this.addParticipants.bind(this);
    this.inviteParticipants = this.inviteParticipants.bind(this);
  }
  componentWillMount() {
    dispatch.lifeCycle.clearContributorSearchFilter()
    this.setState({ noRecord: false, setError: null })
  }

  handleReset(e) {
    this.setState({ checkValid: false, noRecord: false, setError: null })
    document.getElementById("tableSearchReset").reset();
    dispatch.lifeCycle.clearContributorSearchFilter();
    selectedRoleArray = []
    e.stopPropagation()
    e.preventDefault()
    this.setState({firstName:""})
    this.setState({lastName:""})
  }

  handleUserSearch(data) {
    this.setState({ noRecord: true, setError: null })
    this.props.userSearchObject[data.target.name] = data.target.value;
    payload.value = this.props.userSearchObject;
    payload.organizationId = this.props.workspaceId;
    payload.accountId = this.props.accountId;
    if (this.props.isEditModalOpen) { //for edit contributor on resource pane
      payload.addedUsersArray = this.props.participantsData.length > 0 ? this.props.participantsData.map((participant) => { return participant.accountUserId }) : [];
      payload.referenceId = this.props.selectedPracticeLibrary._id;
    }
    else {
      payload.addedUsersArray = this.props.participantsData.length > 0 ? this.props.participantsData.map((participant) => { return participant.accountUserId }) : [];
      payload.addedUsersArray.push(this.props.user._id)
    }

    if (this.props.userSearchObject.firstName && this.props.userSearchObject.lastName && this.props.userSearchObject.email) {
      this.setState({ checkValid: false });
    }
    else {
      this.setState({ checkValid: true });
    }
    if(this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.teamId && 
      this.props.selectedPracticeLibrary.teamId._id) {
        payload.value.team = this.props.selectedPracticeLibrary.teamId._id
    }

    let searchedUser = this.props.searchUserArr.find((user)=>(this.props.userSearchObject.email==user.email))

    if(searchedUser)
    {
      this.setState({firstName:searchedUser.firstName});
      this.setState({lastName:searchedUser.lastName});
    }
    else{
      this.setState({firstName:""})
      this.setState({lastName:""})
    }
    dispatch.lifeCycle.getSearchedUsers(payload);

  }

  handleClose = () => {
    selectedRoleArray = [];
    this.setState({ noRecord: false })
    this.setState({ checkValid: false });
    this.setState({ setError: null })
    this.setState({firstName:""})
    this.setState({lastName:""})
    dispatch.lifeCycle.modalOpen(false);
    dispatch.lifeCycle.clearContributorSearchFilter();
  }
  handleSelectParticipants(event, data, user) {
    let userObj = {
      accountUserId: user._id,
      role: data.value,
      name: user.firstName + ' ' + user.lastName,
      firstName: user.firstName,
      lastName: user.lastName,
      imageUrl: user.profilePic,
      email: user.email
    };

    let temp = selectedRoleArray.filter((participant) => { return participant.accountUserId === userObj.accountUserId });
    if (temp.length === 0) {
      selectedRoleArray.push(userObj);
      user.role = data.value;
    }
    else {
      selectedRoleArray.splice(_.indexOf(selectedRoleArray, temp[0]), 1);
      user.role=""
      // selectedRoleArray.push(userObj);
    }
    this.forceUpdate();
  }

  addParticipants(e) {

    if (this.props.isEditModalOpen) {
      if (selectedRoleArray.length != 0) {
        let temp = this.props.selectedPracticeLibrary.participants.filter((participant) => { return participant.role === 'author' });
        let localTemp = selectedRoleArray.filter((participant) => { return participant.role === 'author' });
        if ((temp.length === 1 && localTemp.length === 0) || (temp.length === 0 && localTemp.length === 1)) {
          let newParticipantArray = [];
          selectedRoleArray.map(function (item, index) {
            return (
              (this.props.selectedPracticeLibrary.participants).push(item),
              newParticipantArray.push(item)
            )
          }, this)
          this.props.selectedPracticeLibrary.newParticipantArray = newParticipantArray;
          this.props.selectedPracticeLibrary.String = 'addParticipantsInUpdatePlaybook';
          this.props.selectedPracticeLibrary.organizationName = this.props.selectedOrganisation.name;

          dispatch.lifeCycle.updatePacksList({ _id: this.props.selectedPracticeLibrary._id, data: { participants: this.props.selectedPracticeLibrary.participants } })
          dispatch.lifeCycle.editPackAsync({ selectedPack: this.props.selectedPracticeLibrary, user: this.props.user })
          selectedRoleArray = [];
          dispatch.lifeCycle.modalOpen(false);
          dispatch.lifeCycle.clearContributorSearchFilter();
          this.setState({ noRecord: false, setError: null })
        }
        else {
          toastr.error('Message', 'Playbook can have only one designer.')
          e.stopPropagation()
          e.preventDefault()
        }
      }
    } //end of if
    else {
      selectedRoleArray.map(function (item, index) {
        return (
          this.props.participantsData.push(item)
        )
      }, this)

      dispatch.lifeCycle.setParticipantsAsync(this.props.participantsData);
      selectedRoleArray = [];
      dispatch.lifeCycle.modalOpen(false);
      this.setState({ noRecord: false, setError: null })
      dispatch.lifeCycle.clearContributorSearchFilter();
    }

  }

  handleChange = (e, { value }) => {
    this.setState({ packRole: value });
  }

  async inviteParticipants(formData) {
    if (formData.firstName === undefined || formData.lastName === undefined || formData.email === undefined) {
      this.setState({ checkValid: true });
    }
    else {
      formData.role = this.state.packRole;
      formData.organizationId = this.props.selectedOrganisation.id;
      formData.from = this.props.user._id;
      formData.referenceCollection = 'practices';
      let temp = this.props.invitedUsersArray.length && this.props.invitedUsersArray.filter((invite) => { return invite.email === formData.email });
      let participantTemp = this.props.participantsData.length && this.props.participantsData.filter((participant) => { return participant.email === formData.email });
      if (temp == 0 && participantTemp == 0) {
        if (this.props.isEditModalOpen) { //for edit contributor on resource pane
          formData.referenceId = this.props.selectedPracticeLibrary._id;
          formData.accountId = this.props.selectedPracticeLibrary.accountId;
          formData.teamName = this.props.selectedPracticeLibrary.name;
          await dispatch.lifeCycle.createInvitationForPlaybookAsync(formData);
        }
        else {
          this.props.invitedUsersArray.push(formData)
          dispatch.lifeCycle.setInvitedParticipantAsync(this.props.invitedUsersArray);
        }
        dispatch.lifeCycle.modalOpen(false);
        dispatch.lifeCycle.clearContributorSearchFilter();
        this.setState({ noRecord: false })
      }
      else {
        if (participantTemp != 0) {
          this.setState({ setError: `User is already added as a ${participantTemp[0].role}.` })
          //toastr.error('Message', `User is already added as a ${participantTemp[0].role}.`)
        }
        else if (temp != 0) {
          this.setState({ setError: 'User is already invited.' })
          //toastr.error('Message', 'User is already invited.')
        }

      }
    }


  }

  render() {
    const inlineStyle = {
      modal: {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto'
      }
    };
    const errorLabel = <div className="customErrorLabel" />;
    return (
      <Modal
        size='medium'
        open={this.props.isModalOpen}
        centered
        style={inlineStyle.modal}
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className="basicModal"
        onClose={this.handleClose}
        closeIcon
      >
        <Modal.Header>
          <span className='primary'><b>Add/Invite Participants inside {this.props.selectedPracticeLibrary ? this.props.selectedPracticeLibrary.name : 'Playbook'}</b></span>
        </Modal.Header>
        <div style={{ "marginLeft": "15px", "marginRight": "15px" }}>
          <Form id='tableSearchReset'
            name="inviteForm"
            onValidSubmit={(formData) => { this.inviteParticipants(formData) }}
          >
            <Modal.Content>
              <Grid className="inviteForm">
                <Grid.Row style={{display:"flex",alignItems:"baseline"}}>
                  <Grid.Column width={5} style={{display:"flex",flexDirection:"column"}}>
                  <label htmlFor="firstName">First Name<span style={{ color: "red", position: "relative", top: "-2px", left: "5px" }}>*</span></label>
                    <Form.Input
                      name="firstName"
                      id="firstName"
                      placeholder="First Name"
                      value={this.state.firstName}
                      required
                      validations="isAlpha"
                      autocomplete="off"
                      onChange={this.handleUserSearch}
                      errorLabel={<span style={{ color: "red", marginTop: "3px", display: "block" }}>{errorLabel}</span>}
                      //validations={{ matchRegexp: singleLineText }}
                      validationErrors={{
                        matchRegexp: 'Max limit is 128. No space allowed in starting.',
                        isDefaultRequiredValue:"First name is required",
                      }}
                      instantValidation
                      autoFocus
                      style={{ marginTop: "4px" }}
                    />
                  </Grid.Column>
                  <Grid.Column width={5} style={{display:"flex",flexDirection:"column"}}>
                  <label htmlFor="lastName">Last Name<span style={{ color: "red", position: "relative", top: "-2px", left: "5px" }}>*</span></label>
                    <Form.Input
                      name="lastName"
                      id="lastName"
                      placeholder="Last Name"
                      value={this.state.lastName}
                      required
                      validations="isAlpha"
                      autocomplete="off"
                      onChange={this.handleUserSearch}
                      errorLabel={<span style={{ color: "red", marginTop: "3px", display: "block" }}>{errorLabel}</span>}
                      //validations={{ matchRegexp: singleLineText }}
                      validationErrors={{
                        matchRegexp: 'Max limit is 128. No space allowed in starting.',
                        isDefaultRequiredValue:"Last name is required",
                      }}
                      instantValidation
                      style={{ marginTop: "4px" }}
                    />
                  </Grid.Column>
                  <Grid.Column width={6} style={{display:"flex",flexDirection:"column"}}>
                  <label htmlFor="email">Email<span style={{ color: "red", position: "relative", top: "-2px", left: "5px" }}>*</span></label>
                    <Form.Input
                      name="email"
                      id="email"
                      placeholder="Email"
                      required
                      validations="isEmail"
                      icon="envelope"
                      autocomplete="off"
                      iconPosition="left"
                      onChange={this.handleUserSearch}
                      // errorLabel={errorLabel}
                      errorLabel={<span style={{ color: "red", marginTop: "3px", display: "block" }}>{errorLabel}</span>}
                      validationErrors={{
                        isEmail: 'This is not a valid email',
                        isDefaultRequiredValue: 'Email is required',
                      }}
                      instantValidation
                      style={{ marginTop: "4px" }}
                    />
                  </Grid.Column>


                </Grid.Row>

                {this.state.noRecord && this.props.searchUserArr && this.props.searchUserArr.length > 0 ?
                  <Grid.Row>
                    <br />
                    <Table celled>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell width={3}>First Name</Table.HeaderCell>
                          <Table.HeaderCell width={3}>Last Name</Table.HeaderCell>
                          <Table.HeaderCell width={5}>E-mail</Table.HeaderCell>
                          <Table.HeaderCell colSpan={this.props.showResourecePaneFlag !== null ? 3 : 2} width={5}>Select Role</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body>
                        {this.props.searchUserArr.length > 0 ?
                          this.props.searchUserArr.map(function (user, index) {
                            return (
                              <Table.Row key={index}>
                                <Table.Cell className="text-cap word-break sixty wide">{user.firstName}</Table.Cell>
                                <Table.Cell className="text-cap word-break">{user.lastName}</Table.Cell>
                                <Table.Cell>{user.email}</Table.Cell>

                                {this.props.showResourecePaneFlag !== null ?
                                  <Table.Cell>
                                    <Radio label='Designer'
                                      name={'participates' + index}
                                      value='author'
                                      checked={user.role == 'author'}
                                      onClick={(event, data) => { this.handleSelectParticipants(event, data, user) }} />
                                  </Table.Cell> : " "}

                                <Table.Cell>
                                  <Radio label='Reviewer'
                                    name={'participates' + index}
                                    value='reviewer'
                                    checked={user.role == 'reviewer'}
                                    onClick={(event, data) => { this.handleSelectParticipants(event, data, user) }} />
                                </Table.Cell>
                                <Table.Cell>
                                  <Radio label='Contributor'
                                    name={'participates' + index}
                                    value='contributor'
                                    checked={user.role == 'contributor'}
                                    onClick={(event, data) => { this.handleSelectParticipants(event, data, user) }} />
                                </Table.Cell>
                              </Table.Row>
                            );
                          }, this) : <Table.Row ><Table.Cell style={{ 'text-align': 'center' }} colSpan='6'>No record found</Table.Cell></Table.Row>}
                      </Table.Body>
                    </Table>
                  </Grid.Row>
                  : ""
                }


                {this.props.isEditModalOpen && this.props.searchInviteUserArr &&
                  this.props.searchInviteUserArr.length > 0 ?
                  <Grid.Row>
                    <span style={{ "color": "#FFC68B", "marginTop": "30px" }}>Already Invited</span>
                    <Table celled>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell width={3}>First Name</Table.HeaderCell>
                          <Table.HeaderCell width={3}>Last Name</Table.HeaderCell>
                          <Table.HeaderCell width={5}>E-mail</Table.HeaderCell>
                          <Table.HeaderCell width={5}>Role</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body>
                        {this.props.searchInviteUserArr && this.props.searchInviteUserArr.length > 0 ?
                          this.props.searchInviteUserArr.map(function (invite, index) {
                            return (
                              <Table.Row key={index}>
                                <Table.Cell className="text-cap">{invite.firstName}</Table.Cell>
                                <Table.Cell className="text-cap">{invite.lastName}</Table.Cell>
                                <Table.Cell>{invite.email}</Table.Cell>
                                <Table.Cell className="text-cap">{invite.role}</Table.Cell>
                              </Table.Row>
                            );
                          }, this) : <Table.Row ><Table.Cell style={{ 'text-align': 'center' }} colSpan='6'>No record found</Table.Cell></Table.Row>}
                      </Table.Body>
                    </Table>
                  </Grid.Row>
                  : ""
                }
                {this.state.noRecord && this.state.checkValid === false && this.state.setError === null && this.props.searchUserArr && this.props.searchInviteUserArr
                  && this.props.searchUserArr.length == 0
                  && this.props.searchInviteUserArr.length == 0 ?
                  <Grid.Row>
                    <Message color='yellow' className="inviteUserWarning">
                      <span>
                        User not found. Please enter details to invite the user.
                        </span>
                    </Message>

                  </Grid.Row> : ''}

                {this.state.setError ?
                  <Grid.Row>
                    <Message color='yellow' className="inviteUserWarning">
                      <span>
                        {this.state.setError}
                      </span>
                    </Message>
                  </Grid.Row>
                  : ''}

              </Grid>

            </Modal.Content>
            <Modal.Actions>
              {this.state.noRecord && !this.state.checkValid && this.state.setError === null && this.props.searchUserArr && this.props.searchInviteUserArr
                && this.props.searchUserArr.length == 0
                && this.props.searchInviteUserArr.length == 0 ?
                <Form.Group grouped className="roleCheck">
                  <label >Select Playbook role <span className='clr-darkRed'> * </span></label>
                  <Form.Group>
                    <Form.Radio
                      name='packRole'
                      label='Reviewer'
                      value='reviewer'
                      checked={this.state.packRole === 'reviewer'}
                      onChange={this.handleChange}
                      style={{ "marginRight": "20px" }}
                    />
                    <Form.Radio
                      name='packRole'
                      label='Contributor'
                      value='contributor'
                      checked={this.state.packRole === 'contributor'}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                </Form.Group>
                : ''}

              <div
                style={{ "text-align": "right", "padding": "10px 0" }}
                className="actionInFormcy border-none">
                {this.props.searchUserArr && this.props.searchUserArr.length || !this.state.noRecord ?
                  <Button
                    id='addbtn'
                    onClick={e => this.addParticipants(e)}
                    className="button-submit float-right"
                    disabled={(this.props.searchUserArr && this.props.searchUserArr.length === 0) || (selectedRoleArray.length === 0)} type="submit">
                    Add </Button> : ''}
                {this.state.noRecord && this.props.searchUserArr && this.props.searchUserArr.length === 0 ?
                  <Button
                    id='invitebtn'
                    className="button-submit  float-right"
                    disabled={this.props.searchInviteUserArr && this.props.searchInviteUserArr.length !== 0 || this.state.checkValid} type="submit">
                    Invite
             </Button> : ''}
                <Button
                  id='resetBtn'
                  className="button-cancel float-right"
                  onClick={e => this.handleReset(e)}
                  type="button">
                  Reset</Button>
                <Button
                  id='cancelBtn'
                  className="button-cancel"
                  onClick={this.handleClose}
                  type="button">
                  Close </Button>
              </div>
            </Modal.Actions>
          </Form>
        </div>
      </Modal >
    )
  }
}

export default ContributorsModal